import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FormControl, Validators } from '@angular/forms';
import { ToolsService } from 'src/app/services/tools.service';
import { AuthService } from 'src/app/services/auth.service';
import { AnalyticsService } from 'src/app/services/analytics.service';

@Component({
  selector: 'app-restore-password',
  templateUrl: './restore-password.page.html',
  styleUrls: ['./restore-password.page.scss'],
})
export class RestorePasswordPage implements OnInit {
  restorePasswordQuestions: any;


  constructor(
    public modalController: ModalController,
    public toolsService:  ToolsService,
    public authService: AuthService, 
    private analyticsService: AnalyticsService
  ) { 
    this.analyticsService.AnalyticsServiceModalView('restore-password');
    this.loadForm();
  }

  ngOnInit() {
  }

  //Function to close modal
  closeModal() {
    this.modalController.dismiss();
  }

  //Function to load Forms
  loadForm(){
    this.restorePasswordQuestions = [
      { label: 'E-mail', format: 'input', type: 'email', formControl: new FormControl('', [Validators.required, Validators.pattern(/.*@.*\..*/)]) },
    ]
  }


  // Function to send restore password email
  async sendRestorePasswordEmail(){
    if(this.toolsService.validateQuestions(this.restorePasswordQuestions)){
      await this.toolsService.showLoader();
      try{
        await this.authService.sendRestorePasswordEmail(this.restorePasswordQuestions[0].formControl.value);
        this.toolsService.showSuccessToast('Correo enviado con éxito. ¡Recuerda revisar en el correo de spam!')
        await this.toolsService.dismissLoader();
      }catch(error){
        this.toolsService.showErrorToast();
        console.error('[RESTORE-PASSWORD-PAGE] sendRestorePasswordEmail()')
        await this.toolsService.dismissLoader();
      }
      
      this.closeModal();
    }else{
      this.toolsService.markAsTouched(this.restorePasswordQuestions)
    }
  }
}
